document.addEventListener("DOMContentLoaded", () => {
  // =========================
  // BOUTON RETOUR
  // =========================
  const backButton = document.getElementById("backButton");
  if (backButton) {
    backButton.addEventListener("click", () => history.back());
  }

  // =========================
  // VIDEO POSTER (YouTube)
  // =========================
  document.querySelectorAll(".video-poster").forEach((poster) => {
    poster.addEventListener("click", () => {
      const id = poster.dataset.videoId;
      if (!id) return;

      poster.classList.add("playing");
      poster.innerHTML = `
        <iframe
          src="https://www.youtube.com/embed/${id}?autoplay=1&modestbranding=1&rel=0&mute=1"
          frameborder="0"
          allow="autoplay; fullscreen; encrypted-media"
          allowfullscreen
          style="width:100%;height:100%;border-radius:16px">
        </iframe>
      `;
    });
  });

  // =========================
  // LIGHTBOX IMAGES
  // =========================
  const images = Array.from(document.querySelectorAll("img.zoomable"));
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  const prevBtn = document.querySelector(".lightbox-arrow.left");
  const nextBtn = document.querySelector(".lightbox-arrow.right");

  if (images.length && lightbox && lightboxImg) {
    let currentIndex = 0;

    const openLightbox = (index) => {
      currentIndex = index;
      lightboxImg.src = images[currentIndex].src;
      lightbox.style.display = "flex";
    };

    const closeLightbox = () => {
      lightbox.style.display = "none";
      lightboxImg.src = "";
    };

    const showNext = () => {
      currentIndex = (currentIndex + 1) % images.length;
      lightboxImg.src = images[currentIndex].src;
    };

    const showPrev = () => {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      lightboxImg.src = images[currentIndex].src;
    };

    images.forEach((img, index) => {
      img.addEventListener("click", () => openLightbox(index));
    });

    if (nextBtn) {
      nextBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        showNext();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        showPrev();
      });
    }

    lightbox.addEventListener("click", closeLightbox);

    document.addEventListener("keydown", (e) => {
      if (lightbox.style.display !== "flex") return;
      if (e.key === "ArrowRight") showNext();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "Escape") closeLightbox();
    });
  }

  // =========================
  // COLONNES PROJECTS
  // =========================
  const projects = document.getElementById("projects");
  const oneColumnBtn = document.getElementById("oneColumn");
  const twoColumnsBtn = document.getElementById("twoColumns");

  if (projects && oneColumnBtn && twoColumnsBtn) {
    oneColumnBtn.addEventListener("click", (e) => {
      e.preventDefault();
      projects.classList.add("one-column");
      projects.classList.remove("two-columns");

      oneColumnBtn.classList.add("active");
      twoColumnsBtn.classList.remove("active");
    });

    twoColumnsBtn.addEventListener("click", (e) => {
      e.preventDefault();
      projects.classList.add("two-columns");
      projects.classList.remove("one-column");

      twoColumnsBtn.classList.add("active");
      oneColumnBtn.classList.remove("active");
    });
  }

  // =========================
  // AFFICHE ANIMÉE (IntersectionObserver)
  // =========================
  const affiche = document.querySelector(".affiche-animee");
  if (affiche) {
    affiche.muted = true;
    affiche.playsInline = true;

    const tryPlay = async () => {
      try {
        await affiche.play();
      } catch (e) {}
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (affiche.readyState >= 2) {
              tryPlay();
            } else {
              affiche.addEventListener("canplay", tryPlay, { once: true });
              affiche.load();
            }
          } else {
            affiche.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(affiche);
  }

  // =========================
  // NELA VIDEO
  // =========================
  const nelaVideo = document.getElementById("nelaVideo");
  const playBtn = document.getElementById("playBtn");

  if (nelaVideo && playBtn) {
    playBtn.addEventListener("click", (e) => {
      e.preventDefault();
      nelaVideo.play();
      playBtn.classList.add("hidden");
      nelaVideo.setAttribute("controls", "controls");
    });
  }
});
